import { notify } from '../../actions/notifications';
import { changeFrequency } from '../../actions/savedSearches/actions';
import {
  TWebChangeEmailSubscriptionFrequencyResponse,
  fetchWebChangeEmailSubscriptionFrequency,
} from '../../repositories/saved-searches/v1/web/change-email-subscription-frequency';
import { ENotificationStyle } from '../../types/notifications';
import { TThunkAction } from '../../types/redux';
import { EFrequency } from '../../types/savedSearch';

export interface IChangeFrequencySavedSearchParameters {
  id: number;
  frequency: EFrequency;
}

export const changeFrequencySavedSearch =
  ({ id, frequency }: IChangeFrequencySavedSearchParameters): TThunkAction<Promise<void>> =>
  async (dispatch, getState, { httpApi, logger }) => {
    const showError = () =>
      dispatch(notify('Не удалось изменить частоту. Попробуйте повторить попытку.', ENotificationStyle.Error));

    try {
      const { statusCode, response }: TWebChangeEmailSubscriptionFrequencyResponse =
        await fetchWebChangeEmailSubscriptionFrequency({
          httpApi,
          parameters: {
            frequency,
            savedSearchId: id,
          },
        });

      if (statusCode === 200) {
        dispatch(changeFrequency({ id, frequency, status: 'active' }));
      }

      if (statusCode === 400) {
        showError();
        logger.warning(response.message || 'Failed change saved searche frequency (400 status code)');
      }
    } catch (e) {
      showError();
      logger.error(e, { description: 'Failed change saved searche frequency' });
    }
  };
